import React, { useEffect, useState } from 'react';
import Header from '../common/Header';
import { useParams } from 'react-router-dom';
import AddressDetails from "./AddressDetails";
import { useNavigate } from "react-router-dom";
import httpService from "../../services/HttpService";

const AddressSingle = () => {
    const { addressId } = useParams(); // Get the 'id' from the route path
    const [address, setAddress] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (addressId) {
            // Fetch the address by ID from the API using httpService
            const fetchAddress = async () => {
                try {
                    const data = await httpService.get(`/address/${addressId}`).then(response => response.json()); // Use httpService.get
                    setAddress(data);
                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };

            fetchAddress();
        } else {
            // No address ID in the URL, so we're adding a new address
            setLoading(false);
        }
    }, [addressId]);

    const handleAddressUpdate = async (updatedAddress) => {
        try {
            let data;
            if (addressId) {
                // Use httpService.put for updating an existing address
                data = await httpService.put(`/address/${addressId}`, updatedAddress);
            } else {
                // Use httpService.post for creating a new address
                data = await httpService.post('/address', updatedAddress);
            }

            console.log(`${addressId ? 'Updated' : 'Created'} Address:`, data.json());

            // Optionally handle success, like redirecting the user or showing a message
            navigate('/address-list');
        } catch (err) {
            console.error(err.message);
        }
    };

    // if (loading) return <p>Loading...</p>;
    if (loading) return <p></p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <Header />
            <div className="address-single-page">
                {/* Reuse OrderAddressSelect component to edit the selected address */}
                <AddressDetails
                    initialData={address || null} // Pass the existing address if available, else null
                    onSubmit={handleAddressUpdate} // Handle the update when form is submitted
                    buttonText="СОХРАНИТЬ"
                    buttonLink="/address-list"
                />
            </div>
        </>
    );
};

export default AddressSingle;